export default {
      id: "shevron-down-usage",
      viewBox: "0 0 15 10",
      url: __webpack_public_path__ + "icons.svg#shevron-down",
      toString: function () {
        return this.url;
      }
    }